import { AxiosInstance } from 'axios'

import { iamDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiOauthCodePostRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/iam'

export const oauthCodePost = async (
  instance: AxiosInstance,
  params: DefaultApiOauthCodePostRequest
) => {
  return await iamDefaultApiFactory(instance).oauthCodePost(params)
}

// Do Not Remove this line ===@import api client===
